class GoogleSheetsService {
  constructor() {
    // Use backend API instead of direct Google Sheets API
    this.baseUrl = process.env.REACT_APP_SHEETS_API_URL || 'http://localhost:3001/api/sheets';
    this.initialized = false;
  }

  async init() {
    if (this.initialized) return;
    
    try {
      // Test connection to backend
      const response = await fetch(`${this.baseUrl}/test`);
      if (!response.ok) {
        throw new Error('Backend API not available');
      }
      
      this.initialized = true;
    } catch (error) {
      console.error('Failed to initialize Google Sheets service:', error);
      throw new Error('Google Sheets service initialization failed');
    }
  }

  async addLoanToSheet(loanData) {
    try {
      await this.init();
      
      console.log('🔵 Sending loan data to backend API:', loanData);
      
      const response = await fetch(`${this.baseUrl}/add-loan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(loanData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to add loan to sheet');
      }

      const result = await response.json();
      console.log('✅ Loan added to Google Sheets:', result);
      return result;
    } catch (error) {
      console.error('❌ Error adding loan to sheet:', error);
      throw error;
    }
  }

  async updateLoanInSheet(loanId, updatedData) {
    try {
      await this.init();
      
      console.log('🔵 Updating loan in Google Sheets:', loanId, updatedData);
      
      const response = await fetch(`${this.baseUrl}/update-loan`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ loanId, ...updatedData })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update loan in sheet');
      }

      const result = await response.json();
      console.log('✅ Loan updated in Google Sheets:', result);
      return result;
    } catch (error) {
      console.error('❌ Error updating loan in sheet:', error);
      throw error;
    }
  }

  async testConnection() {
    try {
      const response = await fetch(`${this.baseUrl}/test`);
      
      if (!response.ok) {
        throw new Error('Backend API connection failed');
      }
      
      const result = await response.json();
      return result;
    } catch (error) {
      return { 
        success: false, 
        message: error.message 
      };
    }
  }
}

export default GoogleSheetsService;